<template>
    <div>
        <con-tab></con-tab>
        <need-nei ></need-nei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import NeedNei from "./base/dongtai";
    export default {
        name: "dongtai",
        components:{
            ConTab,
            NeedNei,
        },
    }
</script>

<style scoped>

</style>